var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.9997 108.167C78.0075 108.167 93.4163 92.758 93.4163 73.7502C93.4163 54.7424 78.0075 39.3335 58.9997 39.3335C39.9919 39.3335 24.583 54.7424 24.583 73.7502C24.583 92.758 39.9919 108.167 58.9997 108.167Z",
    stroke: "#A0A3BD",
    strokeWidth: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59 63.9167V83.5834",
    stroke: "#A0A3BD",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8327 68.8333C65.8327 72.6073 62.7733 75.6667 58.9993 75.6667C55.2254 75.6667 52.166 72.6073 52.166 68.8333C52.166 65.0594 55.2254 62 58.9993 62C62.7733 62 65.8327 65.0594 65.8327 68.8333Z",
    fill: "#A0A3BD",
    stroke: "#A0A3BD",
    strokeWidth: 6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6663 24.5834C78.6663 13.7218 69.8613 4.91675 58.9997 4.91675C48.1381 4.91675 39.333 13.7218 39.333 24.5834V44.2501",
    stroke: "#A0A3BD",
    strokeWidth: 6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.adb8a758fce5caf891668574c3c41dda.svg";
export { ForwardRef as ReactComponent };